import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, ClipboardList, TrendingUp, FileText, CheckSquare, Building2, Shield } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const allNavItems = [
  { name: 'Home', path: '/dashboard', icon: Home },
  { name: 'Team', path: '/teams', icon: Shield },
  { name: 'Players', path: '/players', icon: Users },
  { name: 'Assess', path: '/assess', icon: ClipboardList },
  { name: 'Develop', path: '/develop', icon: TrendingUp },
  { name: 'Reports', path: '/reports', icon: FileText },
  { name: 'Tasks', path: '/tasks', icon: CheckSquare },
  { name: 'Club', path: '/club', icon: Building2 },
];

export function MobileNav() {
  const location = useLocation();
  const { user } = useAuth();

  const isClubRole = user?.role === 'CLUB_ADMIN';
  const navItems = allNavItems.filter((item) => item.name !== 'Club' || isClubRole);

  // Calculate grid cols: base 6 items (Home, Players, Assess, Develop, Reports, Tasks) + Club if admin
  const colCount = navItems.length;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-inset-bottom z-50">
      <nav className={`grid h-16`} style={{ gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))` }}>
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
            (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center gap-1 ${
                isActive ? 'text-blue-700' : 'text-gray-500'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-xs font-medium">{item.name}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
